<i18n>
en:
  title: "Menu"
  checkin:
    label: "Check-in"
  checkout:
    label: "Check-out"
  edit:
    label: "Shop edit"
  holiday:
    label: "Regist holiday"
  image:
    label: "Regist image"
  recipe:
    label: "Regist Recipe"
  signout:
    label: "Sign out"
ja:
  title: "メニュー"
  checkin:
    label: "チェックイン"
  checkout:
    label: "チェックアウト"
  edit:
    label: "店舗情報編集"
  holiday:
    label: "休日登録"
  image:
    label: "画像登録"
  recipe:
    label: "レシピ登録"
  signout:
    label: "ログアウト"
</i18n>

<template lang="pug">
  div
    h1.white--text.text-center|{{$t('title')}}

    v-container
      v-row.menu
        v-col(cols="12")
          v-btn.menu-text.white--text(block color="primary" height="18vh" :to="{name:'ShopCheckIn'}")|{{$t('checkin.label')}}
        v-col(cols="12")
          v-btn.menu-text.white--text(block color="primary" height="18vh" :to="{name:'ShopCheckOut'}")|{{$t('checkout.label')}}
        v-col(cols="12")
          v-btn.menu-text.white--text(block color="teal" height="1.4em" :to="{name:'ShopEdit'}")|{{$t('edit.label')}}
        v-col(cols="12")
          v-btn.menu-text.white--text(block color="teal" height="1.4em" :to="{name:'ShopImage'}")|{{$t('image.label')}}
        //- v-col(cols="12")
        //-   v-btn.menu-text.white--text(block color="teal" height="1.4em" :to="{name:'ShopHoliday'}")|{{$t('holiday.label')}}
        //- v-col(cols="12")
        //-   v-btn.menu-text.white--text(block color="teal" height="1.4em" :to="{name:'ShopRecipeList'}")|{{$t('recipe.label')}}
        v-col.mt-6(cols="12" align="right")
          strong
            a(href="#" @click="signout")|{{$t('signout.label')}}
</template>

<script>
export default {
  methods: {
    /**
     * サインアウト
     */
    signout () {
      this.api.logout({})
      this.$store.commit('login_info', null)
      this.$router.push({name: 'Top'})
    }
  }
}
</script>

<style lang="sass" scoped>
h1
  font-size: 48px
  text-shadow: 0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444
  word-break: keep-all

.menu-text
  font-size: 34px
</style>
